// extracted by mini-css-extract-plugin
export var container = "_1e-0";
export var disabled = "_1e-4";
export var fullWidth = "_1e-3";
export var lined = "_1e-1";
export var selected = "_1e-5";
export var tab = "_1e-2";